import { HTMLAttributes } from 'react';
import { ActionButton, cardStyles, Typography } from '../../ui';
import { twMerge } from 'tailwind-merge';
import { IconDownloadAlt, IconTimes } from '@maia/icons';
import { getFileIconSourceFromMimeType } from '@maia/utils';
import { match } from 'ts-pattern';

type Props = {
  name: string;
  mimetype: string;
} & Omit<HTMLAttributes<HTMLDivElement>, 'children'> &
  (
    | {
        action: 'delete';
        onDelete: () => void;
      }
    | {
        action: 'download';
        onDownload: () => void;
      }
  );

export function UploadedFile(props: Props) {
  const { name, mimetype, className, ...rest } = props;

  return (
    <div
      className={twMerge(
        cardStyles({ variant: 'outlined' }),
        'p-12 flex items-center gap-x-12',
        className,
      )}
      {...rest}
    >
      <div className="min-w-20 w-20 h-20 flex items-center justify-center">
        <img
          src={`/images/file-types/${getFileIconSourceFromMimeType(mimetype)}`}
          alt={name}
          className="object-contain"
        />
      </div>
      <Typography
        variant="body-xs"
        weight="regular"
        className="text-grayscale300 flex-1"
      >
        {name}
      </Typography>
      {match(rest)
        .with({ action: 'delete' }, ({ onDelete }) => (
          <ActionButton size="small" icon={IconTimes} onPress={onDelete} />
        ))
        .with({ action: 'download' }, ({ onDownload }) => (
          <ActionButton
            size="small"
            icon={IconDownloadAlt}
            onPress={onDownload}
          />
        ))
        .otherwise(() => null)}
    </div>
  );
}
